import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer, // Đăng ký authSlice vào store
    // Thêm các reducer khác ở đây khi cần
  },
  // Có thể thêm middleware, devTools, preloadedState ở đây
});
